import * as React from "react";
import { generate } from "shortid";
import type { LinksBlockData, Link } from "@plinknz/tah-website-elements";
import { formatMultilineText } from "@plinknz/tah-website-elements";

interface LinksBlockProps {
    data: LinksBlockData;
}

export const LinksBlock = ({ data }: LinksBlockProps) => {
    const { title, description, links } = data;
    const renderItem = ({ title: itemTitle, url }: Link) => (
        <a
            href={url}
            className="links-block-item"
            key={generate()}
            rel="noreferrer"
            target="_blank"
            download>
            <span className="links-block-item-title">{itemTitle || url}</span>
            <div className="links-block-item-meta">
                <i className="links-block-item-icon fas fa-external-link-alt fa-lg" />
            </div>
        </a>
    );

    return (
        <div
            className="links-block || constrain-width"
            data-testid="links-block">
            {title && (
                <h3 className="links-block-title || heading-3">{title}</h3>
            )}
            {description && (
                <div
                    className="links-block-description"
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: formatMultilineText(description),
                    }}
                />
            )}
            <div className="links-block-list">{links.map(renderItem)}</div>
        </div>
    );
};
